var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80664 1.69238C5.25029 1.69238 1.55664 5.38603 1.55664 9.94238C1.55664 14.4987 5.25029 18.1924 9.80664 18.1924C14.363 18.1924 18.0566 14.4987 18.0566 9.94238C18.0566 5.38603 14.363 1.69238 9.80664 1.69238ZM0.0566406 9.94238C0.0566406 4.55761 4.42186 0.192383 9.80664 0.192383C15.1914 0.192383 19.5566 4.55761 19.5566 9.94238C19.5566 15.3272 15.1914 19.6924 9.80664 19.6924C4.42186 19.6924 0.0566406 15.3272 0.0566406 9.94238ZM8.80664 5.44238C8.80664 4.8901 9.25436 4.44238 9.80664 4.44238C10.3589 4.44238 10.8066 4.8901 10.8066 5.44238C10.8066 5.99467 10.3589 6.44238 9.80664 6.44238C9.25436 6.44238 8.80664 5.99467 8.80664 5.44238ZM10.5566 14.9424V7.94238H9.05664V14.9424H10.5566Z",
    fill: "#F99F07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOrangeIcon);
export default __webpack_public_path__ + "static/media/info-orange-icon.0982396c3f8e0e40fbac61f92c907b6f.svg";
export { ForwardRef as ReactComponent };